import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from 'app/component/component.module';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {DhteComponent} from './dhte.component';

@NgModule({
    imports: [ComponentModule, CommonModule],
    declarations: [DhteComponent],
    entryComponents: [DhteComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(DhteComponent),
            multi: true,
        },
    ],
})
export class DhteModule {}
